export default "__VITE_ASSET__CIJaoDvE__"